import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

// @ts-ignore - no typing info for YML files
import carrierData from 'resources/carriers.yml';

import { makeBtStyles } from '../Theme';
import CarrierIcon from '../components/CarrierIcon';
import { Carrier } from '../dataProviders';

import { CostOption, ReturnType } from './useFindOrder';


const useStyles = makeBtStyles( theme => ({
  root: {
    border: '1px solid #DEDEDE',
    padding: '20px',
    display: 'flex'
  },
  carrierIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '110px' // not necessary but prevents jump when icon loads late
  },
  carrierIcon: {
    width: '60px',
    marginLeft: '20px',
    marginRight: '30px'
  },
  title: {
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '19px'
  },
  text: {
    margin: '0',
    marginTop: '10px',
    fontSize: '14px',
    lineHeight: '20px',
    '&:empty': {
      display: 'none'
    }
  }
}));


export default function ReturnShippingDescriptor({
  className='', costOption
}:{
  className: string, costOption: CostOption
}) {
  const classes = useStyles();

  return <div className={classnames(classes.root,className)}>
    <div className={classes.carrierIconWrapper}>
      <CarrierIcon carrier_code={costOption.carrier_code as Carrier} className={classes.carrierIcon} />
    </div>
    <div>
      <div className={classes.title}>
        <ReturnCostTitle costOption={costOption} />
      </div>
      <p className={classes.text}>
        {costOption.text}
      </p>
    </div>
  </div>;
}


const ReturnCostTitle = ({ costOption }:{ costOption: CostOption }) => {
  const intl = useIntl();
  const cost = costOption.cost;
  const formattedCost = parseFloat(cost.amount).toLocaleString(intl.locale, { style: 'currency', currency: cost.currency_code ? cost.currency_code : undefined });
  const carrierName = carrierData[costOption.carrier_code] ? (carrierData[costOption.carrier_code].name + ' ') : '';
  return <>
    { (costOption.type === ReturnType.FlatPerOrder) ? (
      `Print ${formattedCost} ${carrierName}Return Label`
    ):(
      `Print Return Label`
    )}
  </>;
};